import { useEffect, useState } from "react";
import {
  onAddGoals,
  onGetEmployeeGoals,
  onGetOrgGoals,
  onGetTemplateGoals,
} from "../services/goals";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import useNotificationHook from "./useNotificationHook";
import useEmployeeHook from "./useEmployeeHook";
import { useStateSetter } from "./statehooks/UseStateSettersHook";

export default () => {
  interface GoalItemDTO {
    title: string;
    desc: string;
    target: string;
    date: string;
    deptID?: number;
    progress: string;
    positionID: number;
    employeeID?: number;
    templateID: number;
    organizationID: number;
  }
  const { config } = useStateGetter();
  const { SelectedOrg, selectedEmployee } = useStateGetter();
  const [allempgoals, setallempgoals] = useState([]);
  const { setLoading } = useStateSetter();
  const { selectedOrgEmployees } = useEmployeeHook();

  const getEmpGoals = async () => {
    try {
      var emparr = [];
      var res = await onGetOrgGoals(SelectedOrg.id, config);

      res.data.map((item: any) => {
        if (
          item.target == "employee" &&
          item.employeeID == selectedEmployee.id
        ) {
          emparr.push(item);
        }
        if (
          item.target == "organization" &&
          item.organizationID == selectedEmployee.organizationID
        ) {
          emparr.push(item);
        }
        if (item.target == "dept" && item.deptID == selectedEmployee.deptID) {
          emparr.push(item);
        }
        if (
          item.target == "position" &&
          item.positionID == selectedEmployee.positionID
        ) {
          emparr.push(item);
        }
      });
      setallempgoals(emparr);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEmpGoals();
  });
  return { allempgoals, getEmpGoals };
};
